import Vue from "vue";
import Login from "./Login.vue";
import "@/services/validation.js";
import PortalVue from "portal-vue";

Vue.config.productionTip = false;
Vue.use(PortalVue);

declare let grecaptcha: object | null;
declare let ocm: { captchaOptions: { publickey: string | null } };

// wait for captcha to make sure that vueRecaptcha is working properly
const hasCaptcha = !!ocm?.captchaOptions?.publickey;
if (hasCaptcha) {
	let intervalCount = 0;
	const intervalID = window.setInterval(() => {
		if (intervalCount++ > 150) window.clearInterval(intervalID);
		if (typeof grecaptcha === undefined) return;
		renderLoginForm();
		window.clearInterval(intervalID);
	}, 200);
} else {
	renderLoginForm();
}

function renderLoginForm() {
	new Vue({
		render: (h) => h(Login),
	}).$mount("#mf-login");
}
